import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { useAppContext } from '@prisjakt/ui-app-context';
import ExpandableGrid from '@prisjakt/ui-expandable-grid';
import ProductCard from '@prisjakt/ui-product-card';
import ProductImage from '@prisjakt/ui-product-image';
import T from '@prisjakt/ui-translate';

import { useViewportContext } from '../../../../../components/viewport/context';
import AlertButton from '../../../../../components/new-product-releases/components/alert-button';
import { productNavigation as productNavigationAction } from '../../../../product/actions/product';
import { PRISMIC_PRODUCT_LIST_CLICK } from '../../../../../globals/helpers/navigation-action';

import { PrismicSliceProductList } from '../../../../../types';

import * as S from './styles';

type OwnProps = {};
type StateProps = {};
type DispatchProps = {
  productNavigation: (
    type: string,
    index: number
  ) => { type: string; action: any; index: any };
};

type Props = DispatchProps & PrismicSliceProductList;

const ProductList = ({
  title,
  products,
  listType,
  productNavigation,
}: Props) => {
  const { t, linkTo } = useAppContext();
  const { isTablet } = useViewportContext();

  const compareUrl = linkTo('productCompare', {
    products,
  });

  return products && Array.isArray(products) && products.length ? (
    <S.List>
      <S.Header>
        <S.Title data={title} />

        {listType === 'Compare' && (
          <S.CompareButton
            color="primary"
            variant="outlined"
            component={<Link to={compareUrl} />}
          >
            <T domain="product">product-compare.compare</T>
          </S.CompareButton>
        )}
      </S.Header>

      <ExpandableGrid
        limit={isTablet ? 3 : 4}
        expandText={t('common', 'button.show-more')}
        collapseText={t('common', 'button.show-less')}
        items={products.map((product, index) =>
          product ? (
            <ProductCard
              key={product.id}
              link={product.pathName}
              name={product.name}
              image={
                product.media.first && (
                  <ProductImage name={product.name} src={product.media.first} />
                )
              }
              price={
                product.priceSummary.regular || product.priceSummary.alternative
              }
              rating={product.userReviewSummary.rating}
              onClick={() => {
                productNavigation(PRISMIC_PRODUCT_LIST_CLICK, index + 1);
              }}
              footer={
                listType === 'Alert' ? (
                  <AlertButton
                    product={product}
                    text={t('product', 'alert.create-button')}
                    type="PRICE_DROPS"
                  />
                ) : null
              }
            />
          ) : null
        )}
      />
    </S.List>
  ) : null;
};

const mapStateToProps = () => ({});
const dispatchActions = {
  productNavigation: productNavigationAction,
};

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  dispatchActions
)(ProductList);
